const messages = {
  title: 'Ups! Zašto ste ovde?',
  description:
    'Izvinjavamo se zbog neprijatnosti. Izgleda da pokušavate da\n' +
    'pristupite stranici koja je ili obrisana ili nikada nije postojala.',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
